module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3913-d483b2931e3487b84135c414a35a31fb.jpg";